<ml-status-message-popup-v2
  [popupInfo]="statusPopupElement"
  (closeEvent)="closeStatusMessagePopup()"
></ml-status-message-popup-v2>
<ml-popin-action
  [title]="'application.records.preferences.title' | translate"
  [open]="openModifColumns()"
  (closeEvent)="openModifColumns.set(false)"
  (actionEvent)="saveRecordsPreferences()"
  [closeOnAction]="true"
  [actionButtonText]="'application.records.preferences.buttons.confirm' | translate"
  [closeButtonText]="'application.records.preferences.buttons.cancel' | translate"
  [disableActionButton]="disableActionButton()"
>
  <pvmo-records-preferences [openModifColumns]="openModifColumns()" (isError)="disableActionButton.set(true)" />
</ml-popin-action>
@if (this.isUserConnected()) {
  <div class="container">
    <form novalidate (submit)="$event.preventDefault();">
      <div class="filters">
        <div class="filter-fields">
          <ml-text-icon-signal-input
            [iconName]="'magnifying-glass'"
            [class]="'flex-1 min-width-30'"
            [id]="'clientNameChoice'"
            [label]="'application.records.client-name' | translate"
            [maxlength]="50"
            [placeholder]="'application.records.client-name-placeholder' | translate"
            (enterEvent)="searchWithClientName()"
            [formField]="filterForm.name"
          ></ml-text-icon-signal-input>
            <ml-loading-button
              [label]="'application.records.buttons.choose-columns' | translate"
              [priority]="'secondary'"
              [size]="'medium'"
              [icon]="'eye'"
              class="flex-end-element"
              (event)="openPopinPreferences()"
              [loading]="isLoadingChoosePreferences()"
            ></ml-loading-button>
            <ml-loading-button
              [label]="'application.records.buttons.reset-columns' | translate"
              [priority]="'secondary'"
              [size]="'medium'"
              [icon]="'cross-circle'"
              class="flex-end-element"
              (event)="resetColumnsPreferences()"
              [loading]="isLoadingResetPreferences()"
            ></ml-loading-button>

        </div>
        <div class="filter-fields">
          <ml-select-signal
            [class]="'flex-1 min-width-30'"
            [id]="'webstoreIdChoice'"
            [label]="'application.records.pos-choice' | translate"
            [mapValues]="tveiListMap"
            [formField]="filterForm.pos"
          ></ml-select-signal>
          @if (haveAccessToSellerFilter()) {
            @if (!!selectedSeller()) {
              <ml-select-shown-value-signal
                [class]="'flex-1 min-width-30'"
                [id]="'userLoginChoice'"
                [label]="'application.records.seller-choice' | translate"
                [mapValues]="sellerListMap()"
                [showValue]="selectedSeller()"
                [placeholder]="'application.records.seller-placeholder' | translate"
                [formField]="filterForm.seller"
              ></ml-select-shown-value-signal>
            } @else {
              <ml-custom-line-skeleton
                class="skeleton"
                [label]="'application.records.seller-choice' | translate"
                [customHeight]="4.8"
              ></ml-custom-line-skeleton>
            }
          }
          <ml-text-icon-signal-input
            [iconName]="'magnifying-glass'"
            [class]="'flex-1 min-width-30'"
            [id]="'cckNumberChoice'"
            [placeholder]="'application.records.cck-number-placeholder' | translate"
            [label]="'application.records.cck-number' | translate"
            [maxlength]="8"
            (enterEvent)="searchWithCckNumber()"
            (focusout)="searchWithCckNumber()"
            [formField]="filterForm.cckNumber"
          ></ml-text-icon-signal-input>
        </div>
        <div class="unread">
          <mat-checkbox [formField]="filterForm.unreadMessage">
            <span>{{ 'application.records.unread-message' | translate }}</span>
          </mat-checkbox>
        </div>
      </div>
    </form>
    <div #records [tabIndex]="-1" class="records">
      @if (files() || loadedFiles?.length) {
        @if (loadedFiles?.length) {
          <ml-table-v2
            [pagination]="pageEvent"
            [data]="loadedFiles!"
            [expandable]="true"
            [columns]="getColumns()"
            (cellClickedEmitter)="onCellClick($event)"
            (changedPage)="onPageChanged($event)"
            (actionClickedEmitter)="goToAction($event)"
            [isLoadingState]="!files()?.length || isActionPending()"
            [subActions]="translatedReasonTypeChoiceMap"
            (subActionClickedEmitter)="cancelContract($event)"
            (columnClickedEmitter)="sortColumn($event)"
            [defaultSortedColumn]="defaultSortedColumn()"
            [areSortableColumns]="areSortableColumnsMap"
            [lastSortedColumn]="lastSortedColumn()"
          />
        } @else {
          <div class="no-result-screen">
            <div class="no-result">
              {{ 'application.records.no-result' | translate | uppercase }}
            </div>
            @if (hasAtLeastOneFilter()) {
              <ml-loading-button
                [label]="'application.records.reset-filters-button' | translate"
                [size]="'medium'"
                (event)="resetFilters()"
                (keydown)="onKeyDownResetFilters($event)"
              ></ml-loading-button>
            }
          </div>
        }
      } @else {
        <ml-loader />
      }
    </div>
  </div>
}
